import { rotate } from "components/Loader/Loader.styled";
import Text from "components/Text";
import JobPostBg from "images/JobPostBg.png";
import styled from "styled-components";
import theme from "theme";

export const JobPostWrapper = styled.div`
    width: 100%;
    grid-area: main;
    margin: 0 14px;
    border-radius: 24px;
    position: relative;
    height: 100%;
    background-color: ${theme.colors.white};
    padding: 16px 14px;
    /* overflow-y: scroll; */

    @media (${theme.breakpoints.mobileL}) {
        margin-top: 6.5rem;
    }
`;

export const HeadingSection = styled.div`
    width: 100%;
    height: 177px;
    background: radial-gradient(
            50% 50% at 50% 50%,
            rgba(0, 0, 0, 0.8) 0%,
            rgba(0, 0, 0, 0.6) 100%
        ),
        url(${JobPostBg});
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    ${Text.Style} {
        color: #fff;
    }
`;

export const ContentSection = styled.div`
    margin-top: 52px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const AgencyRow = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 80vw;
    height: 20vw;
    overflow-x: auto;
    gap: 1rem;
    margin-top: 1.5rem;
    padding-bottom: 1.5rem;

    .loader {
        animation: ${rotate} 2s linear infinite;
        color: ${theme.colors.purple.primary};
    }
`;

export const Agency = styled.div<{ isSelected: boolean }>`
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 200px;
    cursor: pointer;
    position: relative;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
    transition: all 0.1s ease-in-out;
    border: ${({ isSelected }) =>
        isSelected ? "2px solid #8868EA" : "2px solid transparent"};
    background-color: ${({ isSelected }) =>
        isSelected ? "rgba(136, 104, 234, 0.1)" : "white"};

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
    }
    img {
        width: 200px;
        height: 180px;
        border-radius: 10px;
        object-fit: cover;
    }

    svg {
        display: ${({ isSelected }) => (isSelected ? "block" : "none")};
        position: absolute;
        top: 8px;
        right: 8px;
        color: #8868ea;
        font-size: 24px;
        background-color: white;
        border-radius: 50%;
    }
`;

export const AgencyHeader = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(136, 104, 234, 0.8);
    padding: 10px;
    border-radius: 0 0 10px 10px;
    text-align: center;

    ${Text.Style} {
        color: #fff;
        font-weight: bold;
        font-size: 1rem;
    }
`;

export const AgencyImage = styled.img`
    width: 26px;
    height: 26px;
    border-radius: 50%;
`;

export const LastUsed = styled(Text)`
    font-style: italic;
    font-weight: 400;
    font-size: 10px;
`;

export const ButtonSection = styled.div`
    margin: 2rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3rem;
`;

export const NoDataMessage = styled.p``;
